import * as fieldTypes from '../../../../constants/FieldTypes';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {displayDependentPacksConfirm} from '../../../../_shared/Messages/actions/MessageActions';

let markAllServer;
let setPackageStatusServer;

export function initFunctions(funcs) {
    markAllServer = funcs.markAll;
    setPackageStatusServer = funcs.setPackageStatus;
}

export function showHidePackage(field, isShow) {
    const {type, screen, packid} = field;

    if (type === fieldTypes.TAB) {
        markAll(screen, field.collection.fields, isShow, setRelatedPackagesStatus);
    } else {
        setPackageStatus(screen, packid, isShow, setRelatedPackagesStatus);
    }
}

export function markAll(designScreen, packArray, newStatus, callback) {
    markAllServer && markAllServer(designScreen, packArray, newStatus, callback);
}

export function setPackageStatus(designScreen, packId, status, callback) {
    setPackageStatusServer && setPackageStatusServer(designScreen, packId, status, callback);
}

export function setRelatedPackagesStatus(designScreen, packages) {
    const {collection, selected} = designScreen;
    const {fields} = collection;
    const {type} = selected;
    if (type !== fieldTypes.TAB) {
        if (packages.length > 1) {
            displayDependentPacksConfirm(
                selected.title,
                packages.filter(pack => pack.packid !== selected.name),

                Number(packages[0].status) === 0
                    ? getLocalizedText(texts.hidePackWarn)
                    : getLocalizedText(texts.showPackWarn),
                () => {
                    updatePackagesStatus(packages, fields);
                },
                () => {
                    return;
                }
            );
        } else {
            updatePackagesStatus(packages, fields);
        }
    } else {
        if (selected.collection.fields.length !== packages.length) {
            // removing all the expected changes
            const packagesTemp = packages.slice();
            for (let i = 0; i < selected.collection.fields.length; i++) {
                for (let j = 0; j < packagesTemp.length; j++) {
                    if (selected.collection.fields[i].packid === packagesTemp[j].packid) {
                        packagesTemp.splice(j, 1);
                        j--;
                    }
                }
            }
            if (packagesTemp.length !== 0) {
                // removing all the duplicate
                for (let i = 0; i < packagesTemp.length; i++) {
                    for (let j = i + 1; j < packagesTemp.length; j++) {
                        if (packagesTemp[i].packid === packagesTemp[j].packid) {
                            packagesTemp.splice(j, 1);
                            j--;
                        }
                    }
                }
                displayDependentPacksConfirm(
                    selected.title,
                    packagesTemp,
                    Number(packages[0].status) === 0
                        ? getLocalizedText(texts.hideCategoryWarn)
                        : getLocalizedText(texts.showCategoryWarn),
                    () => updatePackagesStatus(packages, fields)
                );
            } else {
                updatePackagesStatus(packages, fields);
            }
        } else {
            updatePackagesStatus(packages, fields);
        }
    }
}

function updatePackagesStatus(packages, fields) {
    packages.forEach(pack => {
        const {packid, status} = pack;
        fields.forEach(container => {
            container.collection.fields.forEach(currentPackage => {
                if (currentPackage.packid === packid) {
                    currentPackage.showHide(!!status);
                }
            });
        });
    });
}
